import { DraftState } from 'utils/uploadBulletin';
import { SizedAmenityType, AmenityCountType } from 'components/bulletin-form/components/amenity-with-counter/types';

export enum UploadBulletinStep {
  AdditionalInfo = 'additionalInfo',
  Address = 'address',
  Authentication = 'auth',
  BulletinType = 'bulletinType',
  Contacts = 'contacts',
  DealType = 'dealType',
  MainInfo = 'mainInfo',
  Preview = 'preview',
  UploadImage = 'uploadImage',
  PlanType = 'planType',
}


export interface UploadBulletinDraft {
  clear(): void;
  get(): DraftState;
  set(val: DraftState): void;
}

export enum IsExclusive {
  Yes = 'yes',
  No = 'no',
}

export enum AmenityWithExtraDataType {
  Sized = 'sized',
  Count = 'count',
}

export interface ISizedAmenityDataItem {
  type: AmenityWithExtraDataType.Sized;
  value: SizedAmenityType;
}
export interface IAmenityCountDataItem {
  type: AmenityWithExtraDataType.Count;
  value: AmenityCountType;
}

export type IAmenityWithExtraDataItem = ISizedAmenityDataItem | IAmenityCountDataItem;
